import { render, staticRenderFns } from "./wages.vue?vue&type=template&id=06003ba8&scoped=true"
import script from "./wages.vue?vue&type=script&lang=js"
export * from "./wages.vue?vue&type=script&lang=js"
import style0 from "./wages.vue?vue&type=style&index=0&id=06003ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06003ba8",
  null
  
)

export default component.exports